export const ORDER_RES_CODE: Record<string, number> = {
  /**
   * 부분취소불가
   */
  CAN_NOT_CANCEL_PART_ORDER_ITEM: 1102,
} as const;
